import styled from 'styled-components';

const FormContent = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 480px) {
    margin-left: 16px;
    margin-top: 8px;
  }
`;

const Form = styled.form`
  background: rgba(0, 0, 0, 0.3);
  max-width: 400px;
  height: auto;
  z-index: 1;
  display: grid;
  margin: 0 auto;
  padding: 80px 32px;
  border-radius: 5px;
  box-shadow: var(--box-shadow);

  @media (max-width: 400px) {
    padding: 32px 32px;
  }
`;

const FormTitle = styled.h1`
  margin: 40px 0;
  color: var(--color-white);
  font-size: 40px;
  font-weight: 600;
  text-align: center;
  max-width: 400px;
`;

const FormLabel = styled.label`
  margin-bottom: 8px;
  font-size: 14px;
  color: var(--color-white);
`;

const FormInput = styled.input`
  padding: 16px 16px;
  margin-bottom: 32px;
  border: none;
  border-radius: 5px;
`;

const FormButton = styled.button`
  /* background: var(--color-primary); */
  background-size: 200% auto;
  /* background-image: linear-gradient(
    to right,
    #01bf71 0%,
    #92fe9d 51%,
    #01bf71 100%
  ); */
  background-image: linear-gradient(
    to right,
    #895cf2 0%,
    #ffabf4 51%,
    #895cf2 100%
  );
  padding: 16px 0;
  border: none;
  border-radius: 5px;
  color: var(--color-white);
  font-size: 1rem;
  font-weight: 800;
  text-transform: uppercase;
  transition: var(--transition);

  cursor: pointer;
  &:hover {
    transition: var(--transition-hover);
    background-position: right center; /* change the direction of the change here */
  }
`;

const FormText = styled.p`
  text-align: center;
  margin-top: 24px;
  color: var(--color-white);
  font-size: 14px;
`;

export {
  FormContent,
  Form,
  FormTitle,
  FormLabel,
  FormInput,
  FormButton,
  FormText
};
